const VALIDATED_MEASUREMENT_RANGES = Object.freeze({
  fev1: Object.freeze({
    lowerBound: 2,
    upperBound: 5,
    decimals: 2,
  }),
  pef: Object.freeze({
    lowerBound: 350,
    upperBound: 700,
    decimals: 0,
  }),
  rr: Object.freeze({
    lowerBound: 5,
    upperBound: 40,
    decimals: 0,
    inclusive: true,
  }),
  hr: Object.freeze({
    lowerBound: 50,
    upperBound: 120,
    decimals: 0,
  }),
});

function readFiniteNumber(value) {
  return typeof value === "number" && Number.isFinite(value) ? value : null;
}

export function getValidatedMeasurementRange(metric) {
  return VALIDATED_MEASUREMENT_RANGES[metric] ?? null;
}

export function isMeasurementWithinValidatedRange(metric, value) {
  const numericValue = readFiniteNumber(value);
  if (numericValue == null) return false;

  const range = getValidatedMeasurementRange(metric);
  if (!range) return true;

  if (range.inclusive) {
    return numericValue >= range.lowerBound && numericValue <= range.upperBound;
  }

  return numericValue > range.lowerBound && numericValue < range.upperBound;
}

export function getValidatedMeasurementValue(metric, value) {
  const numericValue = readFiniteNumber(value);
  if (numericValue == null) return null;

  return isMeasurementWithinValidatedRange(metric, numericValue)
    ? numericValue
    : null;
}

export function formatValidatedMeasurement(metric, value, fallback = "--") {
  const numericValue = getValidatedMeasurementValue(metric, value);
  if (numericValue == null) return fallback;

  const range = getValidatedMeasurementRange(metric);
  const decimals = range?.decimals ?? 0;

  return decimals > 0
    ? numericValue.toFixed(decimals)
    : String(Math.round(numericValue));
}
